<template>
  <div id="datatable" class="table_wrapper" :class="[propsObj.itemLabel && reportFilterObj && Object.keys(reportFilterObj).length ? 'four-lines-header' : !propsObj.itemLabel && (!reportFilterObj || (reportFilterObj && !Object.keys(reportFilterObj).length)) ? 'two-lines-header' : '']">
        <div class="reportdetails table_view_details" v-if="!customDates">
          <!-- <h3 class="body-2" v-if="$root.CurrentBusiness">{{$root.CurrentBusiness.BusinessName}}</h3> -->
          <!-- <h3 class="body-2" v-if="$root.CurrentBusiness">{{propsObj.reportTitle}}</h3> -->
          <v-card flat>
            <v-card-text class="pt-4 pb-4">
              <!-- <p class="mb-0" v-if="propsObj.itemLabel">
                <span>{{propsObj.itemLabel}}</span>: <span>{{propsObj.itemName}}</span>
              </p> -->

              <p class="cursor-pointer mb-0">
                <span @click="openDialogCustomDates" v-if="propsObj.periodLabel == 'Period'">
                    <span>{{propsObj.periodLabel}}</span>: 
                    <span>{{propsObj.startDate | moment("DD-MMM-YYYY")}}</span> 
                    <span> To </span> 
                    <span>{{propsObj.endDate | moment("DD-MMM-YYYY")}}</span>
                  </span>

                  <span @click="openDatePicker('end', propsObj.endDate)" v-else>
                    <span>{{propsObj.periodLabel}}</span>: 
                    <span>{{propsObj.endDate | moment("DD-MMM-YYYY")}}</span>
                  </span>
              </p>

              <p class="mb-0" v-if="reportFilterObj && Object.keys(reportFilterObj).length">
                <span v-for="(filter, key, index) in reportFilterObj" :key="index">
                  <span>{{filter.name}}</span>: {{filter.value}}{{index!=Object.keys(reportFilterObj).length-1 ? ', ': ''}}
                </span>
              </p>

              <v-menu v-if="propsObj.periodLabel == 'Period'">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small outlined capitalize v-bind="attrs" v-on="on" style="position:absolute;right:16px;top:0px;bottom:0;margin:auto">
                    {{propsObj.selectedPeriod}}&nbsp;<v-icon right>date_range</v-icon>
                  </v-btn>
                </template>
                  <v-list class="pa-0">
                    <v-list-item v-for="(item, index) in periods" :key="index" @click="selectPeriod(item.value)">
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
              </v-menu>

              <!-- <v-menu v-if="$route.params.reportId == 109">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small outlined capitalize v-bind="attrs" v-on="on" style="position:absolute;right:16px;top:0px;bottom:0;margin:auto">
                    {{propsObj.selectedPeriod ? propsObj.selectedPeriod : 'Custom'}}&nbsp;<v-icon right>date_range</v-icon>
                  </v-btn>
                </template>
                  <v-list class="pa-0">
                    <v-list-item v-for="(item, index) in periodsLastDays" :key="index" @click="selectDays(item)">
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
              </v-menu> -->
            </v-card-text>
          </v-card>
          
        </div>

        <v-divider></v-divider>
        
        <template v-if="$route.params.reportId==205 || $route.params.reportId==310 || $route.params.reportId==311 || $route.params.reportId==312 || $route.params.reportId==410 || $route.params.reportId==411 || $route.params.reportId==412 || $route.params.reportId==413 || $route.params.reportId==414 || $route.params.reportId==415 || $route.params.reportId==416 || $route.params.reportId==417 || $route.params.reportId==418 || $route.params.reportId==419 || $route.params.reportId==420 ">
          <div v-if="propsObj.reportData" style="overflow: auto;" :style="{'height':tableHeight ? tableHeight : 'auto'}" :class="{'fixed-width-table': propsObj.columns.length == 2 || propsObj.columns.length == 3, 'two-column': propsObj.columns.length == 2, 'three-column': propsObj.columns.length == 3}">

            <div class="table" full-width>

              <!-- header -->
              <div class="table_row dark-grey-back" style="position: sticky;top: 0;">
                  <div class="table_col" v-for="(item, index) in propsObj.reportData.headerRow" :key="index" :class="{'right-align': item.type=='number'}">
                    <strong>{{item.headerName ? item.headerName : ''}}</strong>
                  </div>
              </div>

              <!-- body -->
            <template v-for="(item, index) in propsObj.reportData.detailRows">
              <div class="table_row body cursor-pointer" v-ripple @click="fn_getDetails($event, item)" :key="index">

                  <div class="table_col" v-for="(col, colIndex) in propsObj.columns" :key="colIndex" :class="{'right-align': typeof(item.cols[col])=='number'}">
                    <span v-if="propsObj.reportData.headerRow[colIndex].type == 'date'" :class="fn_getCustomDateClass(item)">{{item.cols[col] | moment("DD-MMM-YYYY")}}</span>
                    <span :class="{'font-medium': fn_makeRowsColsStrong(item, col)}" v-else-if="$route.params.reportId == 601 || $route.params.reportId == 602 || $route.params.reportId == 603 || $route.params.reportId == 901">
                      <span v-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                      <span v-else>{{item.cols[col] ? item.cols[col] : ''}}</span>
                    </span>

                    <span :class="{'font-medium':item.mainRow}" v-else>
                      <span v-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                      
                      <span v-else-if="$route.params.reportId==109">
                        <template v-if="col == 'expiredIn'">
                          {{item.cols[col] > 0 ? item.cols[col] : ''}}
                        </template>
                        <template v-else>
                          {{item.cols[col] ? item.cols[col] : ''}}
                        </template>
                      </span>
                      
                      <span v-else>{{item.cols[col] ? item.cols[col] : ''}}</span>
                    </span>

                  </div>

                </div>

                <div class="table_row body" :key="'subheaders'+index" v-if="item.subHeaders">
                    <template>
                      <div class="table_col">
                        <strong></strong>
                      </div>
                      <div class="table_col">
                        <strong>{{item.subHeaders.srNo}}</strong>
                      </div>
                      <div class="table_col">
                        <strong>{{item.subHeaders.productName}}</strong>
                      </div>
                      <div class="table_col" v-if="item.subHeaders && item.subHeaders.hsnCode">
                        <strong>{{item.subHeaders.hsnCode}}</strong>
                      </div>
                      <div class="table_col right-align">
                        <strong>{{item.subHeaders.qty}}</strong>
                      </div>
                      <div class="table_col">
                        <strong>{{item.subHeaders.unit}}</strong>
                      </div>
                      <div class="table_col right-align">
                        <strong>{{item.subHeaders.rate}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.discount">
                        <strong>{{item.subHeaders.discount}}</strong>
                      </div>
                      <div class="table_col right-align">
                        <strong>{{item.subHeaders.taxableValue}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage">
                        <strong>{{item.subHeaders.gstPercentage}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cgst">
                        <strong>{{item.subHeaders.cgst}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.sgst">
                        <strong>{{item.subHeaders.sgst}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.utgst">
                        <strong>{{item.subHeaders.utgst}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.igst">
                        <strong>{{item.subHeaders.igst}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage">
                        <strong>{{item.subHeaders.cessPercentage}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage">
                        <strong>{{item.subHeaders.cessOnQtyPercentage}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cess">
                        <strong>{{item.subHeaders.cess}}</strong>
                      </div>
                      <div class="table_col right-align">
                        <strong>{{item.subHeaders.total}}</strong>
                      </div>
                    </template>
                    
                </div>

                  <template v-for="(detailItem, detailItemIndex) in item.cols.itemDetailRows">
                    <div :key="'detailrow'+(detailItemIndex + index)" class="table_row body" v-if="item.cols.itemDetailRows && item.cols.itemDetailRows.length" @click="openTransaction(item.transactionListId, item.transactionId);">    
                      <!-- <div :key="detailItemIndex"> -->
                        <div class="table_col" :key="'blank'+detailItemIndex"></div>
                        <div class="table_col" :key="'srno'+detailItemIndex">{{detailItem.srNo}}</div>
                        <div class="table_col" :key="'name'+detailItemIndex">{{detailItem.productName}}</div>
                        <div class="table_col" :key="'hsn'+detailItemIndex" v-if="item.subHeaders && item.subHeaders.hsnCode">{{detailItem.hsnCode}}</div>
                        <div class="table_col right-align" :key="'qty'+detailItemIndex">{{$root.numberToLocale(detailItem.qty)}}</div>
                        <div class="table_col" :key="'unit'+detailItemIndex">{{detailItem.unit}}</div>
                        <div class="table_col right-align" :key="'rate'+detailItemIndex">{{$root.numberToLocale(detailItem.rate)}}</div>
                        <div class="table_col right-align" :key="'discount'+detailItemIndex" v-if="item.subHeaders && item.subHeaders.discount">{{$root.numberToLocale(detailItem.discount)}}</div>
                        <div class="table_col right-align" :key="'taxable'+detailItemIndex">{{$root.numberToLocale(detailItem.taxableValue)}}</div>
                        <div class="table_col right-align" :key="'gst'+detailItemIndex" v-if="item.subHeaders && item.subHeaders.gstPercentage">{{$root.numberToLocale(detailItem.gstPercentage)}}</div>
                        <div class="table_col right-align" :key="'cgst'+detailItemIndex" v-if="item.subHeaders && item.subHeaders.cgst">{{$root.numberToLocale(detailItem.cgst)}}</div>
                        <div class="table_col right-align" :key="'sgst'+detailItemIndex" v-if="item.subHeaders && item.subHeaders.sgst">{{$root.numberToLocale(detailItem.sgst)}}</div>
                        <div class="table_col right-align" :key="'utgst'+detailItemIndex" v-if="item.subHeaders && item.subHeaders.utgst">{{$root.numberToLocale(detailItem.utgst)}}</div>
                        <div class="table_col right-align" :key="'igst'+detailItemIndex" v-if="item.subHeaders && item.subHeaders.igst">{{$root.numberToLocale(detailItem.igst)}}</div>
                        <div class="table_col right-align" :key="'cessper'+detailItemIndex" v-if="item.subHeaders && item.subHeaders.cessPercentage">{{$root.numberToLocale(detailItem.cessPercentage)}}</div>
                        <div class="table_col right-align" :key="'cessper'+detailItemIndex" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage">{{$root.numberToLocale(detailItem.cessOnQtyPercentage)}}</div>
                        <div class="table_col right-align" :key="'cess'+detailItemIndex" v-if="item.subHeaders && item.subHeaders.cess">{{$root.numberToLocale(detailItem.cess)}}</div>
                        <div class="table_col right-align" :key="'total'+detailItemIndex">{{$root.numberToLocale(detailItem.total)}}</div>
                      <!-- </div> -->                    
                    </div>
                  </template>

                  <div class="table_row body" :key="'subtotal'+index" v-if="item.cols.subTotal">
                    <template>
                      <div class="table_col"></div>
                      <div class="table_col">
                        <strong>{{item.cols.subTotal.srNo}}</strong>
                      </div>
                      <div class="table_col">
                        <strong>{{item.cols.subTotal.productName}}</strong>
                      </div>
                      <div class="table_col" v-if="item.subHeaders && item.subHeaders.hsnCode">
                        <strong>{{item.cols.subTotal.hsnCode}}</strong>
                      </div>
                      <div class="table_col right-align">
                        <strong>{{$root.numberToLocale(item.cols.subTotal.qty)}}</strong>
                      </div>
                      <div class="table_col">
                        <strong>{{item.cols.subTotal.unit}}</strong>
                      </div>
                      <div class="table_col right-align">
                        <strong>{{$root.numberToLocale(item.cols.subTotal.rate)}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.discount">
                        <strong>{{$root.numberToLocale(item.cols.subTotal.discount)}}</strong>
                      </div>
                      <div class="table_col right-align">
                        <strong>{{$root.numberToLocale(item.cols.subTotal.taxableValue)}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage">
                        <strong>{{$root.numberToLocale(item.cols.subTotal.gstPercentage)}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cgst">
                        <strong>{{$root.numberToLocale(item.cols.subTotal.cgst)}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.sgst">
                        <strong>{{$root.numberToLocale(item.cols.subTotal.sgst)}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.utgst">
                        <strong>{{$root.numberToLocale(item.cols.subTotal.utgst)}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.igst">
                        <strong>{{$root.numberToLocale(item.cols.subTotal.igst)}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage">
                        <strong>{{$root.numberToLocale(item.cols.subTotal.cessPercentage)}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage">
                        <strong>{{$root.numberToLocale(item.cols.subTotal.cessOnQtyPercentage)}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cess">
                        <strong>{{$root.numberToLocale(item.cols.subTotal.cess)}}</strong>
                      </div>
                      <div class="table_col right-align">
                        <strong>{{$root.numberToLocale(item.cols.subTotal.total)}}</strong>
                      </div>
                    </template>
                    
                  </div>

                  <div class="table_row body" :key="'billaddons'+index" v-if="item.cols.billAddOns">
                    <template>
                      <div class="table_col"></div>
                      <div class="table_col">                        
                      </div>
                      <div class="table_col">
                      </div>
                      <div class="table_col" v-if="item.subHeaders && item.subHeaders.hsnCode">
                      </div>
                      <div class="table_col right-align">
                      </div>
                      <div class="table_col">
                      </div>
                      <div class="table_col right-align">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.discount">
                      </div>
                      <div class="table_col right-align">
                        <strong>{{item.cols.billAddOns.srNo}}</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cgst">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.sgst">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.utgst">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.igst">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cess">
                      </div>
                      <div class="table_col right-align">
                        <strong>{{$root.numberToLocale(item.cols.billAddOns.total)}}</strong>
                      </div>
                    </template>
                    
                  </div>

                  <div class="table_row body" :key="'tds'+index" v-if="item.cols.tdsAddOns">
                    <template>
                      <div class="table_col"></div>
                      <div class="table_col">                        
                      </div>
                      <div class="table_col">
                      </div>
                      <div class="table_col" v-if="item.subHeaders && item.subHeaders.hsnCode">
                      </div>
                      <div class="table_col right-align">
                      </div>
                      <div class="table_col">
                      </div>
                      <div class="table_col right-align">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.discount">
                      </div>
                      <div class="table_col right-align">
                        <strong>Total Tds</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cgst">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.sgst">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.utgst">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.igst">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cess">
                      </div>
                      <div class="table_col right-align">
                        <strong>{{$root.numberToLocale(item.cols.tdsAddOns.total)}}</strong>
                      </div>
                    </template>
                    
                  </div>

                  <div class="table_row body" :key="'grandtotal'+index" v-if="item.cols.total">
                    <template>
                      <div class="table_col"></div>
                      <div class="table_col">                        
                      </div>
                      <div class="table_col">
                      </div>
                      <div class="table_col" v-if="item.subHeaders && item.subHeaders.hsnCode">
                      </div>
                      <div class="table_col right-align">
                      </div>
                      <div class="table_col">
                      </div>
                      <div class="table_col right-align">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.discount">
                      </div>
                      <div class="table_col right-align">
                        <strong>Total</strong>
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cgst">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.sgst">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.utgst">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.igst">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage">
                      </div>
                      <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cess">
                      </div>
                      <div class="table_col right-align">
                        <strong>{{$root.numberToLocale(item.cols.total.total)}}</strong>
                      </div>
                    </template>
                    
                  </div>
              </template>

                  
              <!-- </div> -->

              <!-- footer -->
              <div class="table_row" style="position:sticky;bottom: -2px;background: #fff;" v-if="propsObj.reportData.footerRow">
                  <div class="table_col" v-for="(col, index) in propsObj.columns" :key="index" 
                  :class="{'right-align': typeof(propsObj.reportData.footerRow[col])=='number'}">
                    <strong>
                        <span v-if="typeof(propsObj.reportData.footerRow[col])=='number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{propsObj.reportData.footerRow[col] ? $root.numberToLocale(propsObj.reportData.footerRow[col]) : ''}}</span>
                        <span v-else>{{propsObj.reportData.footerRow[col] ? propsObj.reportData.footerRow[col] : ''}}</span>
                    </strong>
                  </div>
              </div>
            </div>            
            
          </div>
        </template>

        <template v-else>
          <div v-if="propsObj.reportData" style="overflow: auto;" :style="{'height':tableHeight ? tableHeight : 'auto'}" :class="{'fixed-width-table': propsObj.columns.length == 2 || propsObj.columns.length == 3, 'two-column': propsObj.columns.length == 2, 'three-column': propsObj.columns.length == 3}">

            <div class="table" full-width>

              <!-- header -->
              <div class="table_row dark-grey-back" style="position: sticky;top: 0;">
                  <div class="table_col" v-for="(item, index) in propsObj.reportData.headerRow" :key="index" :class="{'right-align': item.type=='number'}">
                    <strong>{{item.headerName ? item.headerName : ''}}</strong>
                    <!-- <template v-if="$route.params.reportId==201">
                      <strong> {{ item.headerName == 'To Receive' ? $root.fn_getDebitLabel() : item.headerName == 'To Pay' ? $root.fn_getCreditLabel() : item.headerName }}</strong>
                    </template>
                    <template v-else>
                      <strong>{{ item.headerName ? item.headerName : '' }}</strong>
                    </template> -->
                  </div>
              </div>

              <!-- body -->
              <div class="table_row body cursor-pointer" v-ripple v-for="(item, index) in propsObj.reportData.detailRows" @click="fn_getDetails($event, item)" :key="index">
                  <div class="table_col" v-for="(col, colIndex) in propsObj.columns" :key="colIndex" :class="{'right-align': typeof(item.cols[col])=='number' && !fn_isSubItems(item, col, colIndex), 'pl-5':fn_leftPad(item, col, colIndex)}">
                    <span v-if="propsObj.reportData.headerRow[colIndex].type == 'date'" :class="fn_getCustomDateClass(item)">{{item.cols[col] | moment("DD-MMM-YYYY")}}</span>
                    <!-- <span :class="{'font-medium': ($route.params.reportId == 601 || $route.params.reportId == 602 || $route.params.reportId == 603 || $route.params.reportId == 901) && item.accountGroupId}" v-else-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                    <span :class="{'font-medium': ($route.params.reportId == 601 || $route.params.reportId == 602 || $route.params.reportId == 603 || $route.params.reportId == 901) && item.accountGroupId || item.mainRow}" v-else>{{item.cols[col] ? item.cols[col] : ''}}</span> -->
                    <span :class="{'font-medium': fn_makeRowsColsStrong(item, col)}" v-else-if="$route.params.reportId == 601 || $route.params.reportId == 602 || $route.params.reportId == 603 || $route.params.reportId == 901">
                      <span v-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                      <span v-else>{{item.cols[col] ? item.cols[col] : ''}}</span>
                    </span>

                    <span :class="{'font-medium':item.mainRow}" v-else>
                      <span v-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                      
                      <span v-else-if="$route.params.reportId==109">
                        <template v-if="col == 'expiredIn'">
                          {{item.cols[col] > 0 ? item.cols[col] : ''}}
                        </template>
                        <template v-else>
                          {{item.cols[col] ? item.cols[col] : ''}}
                        </template>
                      </span>
                      
                      <span v-else>{{item.cols[col] ? item.cols[col] : ''}}</span>
                    </span>
                    <!-- <span :class="{'font-medium': fn_makeRowsColsStrong(item)}" v-else-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                    <span :class="{'font-medium': ($route.params.reportId == 601 || $route.params.reportId == 602 || $route.params.reportId == 603 || $route.params.reportId == 901) && item.accountGroupId || item.mainRow}" v-else>{{item.cols[col] ? item.cols[col] : ''}}</span> -->
                  </div>
              </div>

              <!-- footer -->
              <div class="table_row" style="position:sticky;bottom: -2px;background: #fff;" v-if="propsObj.reportData.footerRow">
                  <div class="table_col" v-for="(col, index) in propsObj.columns" :key="index" 
                  :class="{'right-align': typeof(propsObj.reportData.footerRow[col])=='number'}">
                    <strong>
                        <span v-if="typeof(propsObj.reportData.footerRow[col])=='number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{propsObj.reportData.footerRow[col] ? $root.numberToLocale(propsObj.reportData.footerRow[col]) : ''}}</span>
                        <span v-else>{{propsObj.reportData.footerRow[col] ? propsObj.reportData.footerRow[col] : ''}}</span>
                        <!-- <span v-else>
                          <template v-if="$route.params.reportId==201">
                            {{ propsObj.reportData.footerRow[col] == 'To Receive' ? $root.fn_getDebitLabel() : propsObj.reportData.footerRow[col] == 'To Pay' ? $root.fn_getCreditLabel() : propsObj.reportData.footerRow[col] }}
                          </template>
                          <template v-else>
                            {{propsObj.reportData.footerRow[col] ? propsObj.reportData.footerRow[col] : ''}}
                          </template>
                        </span> -->
                    </strong>
                  </div>
              </div>
            </div>            
        
            <!-- <div class="header" id="tableHeader" style="position: sticky;top: 0;">
                <div class="table" full-width>
                    <div class="table_row">
                        <div class="table_col" v-for="(item, index) in propsObj.reportData.headerRow" :key="index" :class="{'right-align': item.type=='number'}">{{item.headerName ? item.headerName : ''}}</div>
                    </div>
                </div>
            </div>

            <div class="body" id="tableBody" v-if="propsObj.reportData && propsObj.reportData.detailRows" :class="{'three-row-card':propsObj.reportData.summaryRows && propsObj.reportData.summaryRows.length==3}">
                <div class="table" full-width>
                  <div class="table_row" v-for="(item, index) in propsObj.reportData.detailRows" @click="fn_getDetails(item)" :key="index">
                      <div class="table_col" v-for="(col, colIndex) in propsObj.columns" :key="colIndex" :class="{'right-align': typeof(item.cols[col])=='number'}">
                        <span v-if="propsObj.reportData.headerRow[colIndex].type == 'date'">{{item.cols[col] | moment("DD-MMM-YYYY")}}</span>
                        <span :class="{'font-medium': ($route.params.reportId == 601 || $route.params.reportId == 602 || $route.params.reportId == 603 || $route.params.reportId == 901) && item.accountGroupId || item.mainRow}" v-else>{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                      </div>
                  </div>
                </div>
            </div>

            <div class="footer" id="tableFooter" style="position:sticky;bottom: 0;background: #fff;" v-if="propsObj.reportData.footerRow && $route.params.reportId!=501 && $route.params.reportId!=502">
                <div class="table" full-width>
                    <div class="table_row">
                        <div class="table_col" v-for="(col, index) in propsObj.columns" :key="index" 
                        :class="{'right-align': typeof(propsObj.reportData.footerRow[col])=='number'}">
                          <strong>{{propsObj.reportData.footerRow[col] ? $root.numberToLocale(propsObj.reportData.footerRow[col]) : ''}}</strong>
                        </div>
                    </div>
                </div>
            </div> -->

          </div>
        </template>

  </div>
</template>

<script>
const transactionForms = require('../../../config.js').configs.transactionForms;
  export default{
    props:['reportId', 'propsObj', 'openDialogAndroid', 'getReportItemDetails', 'openDatePicker', 'reportFilterObj', 'openTransaction', 'openAccountDetails', 'openLinkedAccount', 'getSubReportData', 'periods', 'selectPeriod', 'openDialogCustomDates', 'customDates', 'periodsLastDays', 'selectDays'],
    data(){
      return{
        tableHeight:null,
        x: 0,
        y: 0,
        testdata:[{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 1", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -20, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" },{ cols:{"averageRate": null, "brand": null, "categoryName": null, "dqty": -40, "productName": "Item 2", "unitName": "Pieces", "value": null},"productId":"133" }]
      }
    },
    methods:{

      fn_makeRowsColsStrong: function(item, col){
        if((this.$route.params.reportId == 601 || this.$route.params.reportId == 901) && item.accountGroupId){
          return true;
        }
        else if(this.$route.params.reportId == 602 || this.$route.params.reportId == 603){
          if(!item.linkedAccounts){
            return true;
          }
          else if(item.linkedAccounts && item.linkedAccounts.length == 1){
            if(this.$route.params.reportId == 602){
              if((col == 'purchaseAccountName' || col == 'purchaseAmount') && !item.cols.purchaseAccountId){
                return true;
              }
              else if((col == 'saleAccountName' || col == 'saleAmount') && !item.cols.saleAccountId){
                return true;
              }
              else{
                return false;
              }
            }
            else{
              if((col == 'assetAccountName' || col == 'assetAmount') && !item.cols.assetAccountId){
                return true;
              }
              else if((col == 'liabilityAccountName' || col == 'liabilityAmount') && !item.cols.liabilityAccountId){
                return true;
              }
              else{
                return false;
              }
            }
            
          }
          else{
            return false;
          }
        }
        else{
          return false;
        }
      },

      fn_leftPad: function(item, col, colIndex){
        if(!this.fn_makeRowsColsStrong(item, col) && this.$route.params.reportId == 603 && (colIndex == 0 || colIndex == 2)){
          return true;
        }        
        else{
          return false;
        }
      },

      fn_isSubItems: function(item, col, colIndex){
        if(!this.fn_makeRowsColsStrong(item, col) && this.$route.params.reportId == 603 && (colIndex == 1 || colIndex == 3)){
          return true;
        }        
        else{
          return false;
        }
      },

      // fn_getHeaders: function(){
      //   let headers = [];
      //   for(let i in this.propsObj.columns){
      //     let obj = {};
      //     obj.value = this.propsObj.columns[i];
      //     for(let j in this.propsObj.reportData.headerRow){
      //       if(obj.value == this.propsObj.reportData.headerRow[j].value){
      //         obj.text = this.propsObj.reportData.headerRow[j].headerName;
      //         headers.push(obj);
      //         break;
      //       }
      //     }
      //   }
      //   return headers;
      // },

      fn_getTransactionType: function(listId){
        for(let i=0; i<transactionForms.length; i++){
          if(transactionForms[i].id==listId){
            return transactionForms[i].title;
          }
        }
      },

      fn_getDetails: function(event, item, linkedAccount){
        // alert('in');
        // if(this.propsObj.disableClick || this.propsObj.openView){
        //   alert('in');
        //   return;
        // }

        if((this.$route.params.reportId == 302 || this.$route.params.reportId == 402 || this.$route.params.reportId == 503) && item.cols.isGroup){
          return;
        }
        
        this.propsObj.disableClick = true;
        let startDate = this.propsObj.startDate ? this.$moment(new Date(this.propsObj.startDate)).format('YYYY-MM-DD') : null;
        let endDate = this.$moment(new Date(this.propsObj.endDate)).format('YYYY-MM-DD');

        // if(this.propsObj.detailreportId && item.transactionId){
        if((this.$route.params.reportId == 602 || this.$route.params.reportId == 602 || this.$route.params.reportId == 603) && !linkedAccount){
          this.openLinkedAccount(event, item.linkedAccounts);
        }
        else if(this.$route.params.reportId == 201){
          this.getReportItemDetails(event, item.transactionListId, item.transactionId);
          // this.show(event);
        }
        else if(this.$route.params.reportId == 801 || this.$route.params.reportId == 802){
          this.getSubReportData(item.subReportId);
        }
        else if(this.$route.params.reportId == 803){
          this.getSubReportData(item);
        }
        else if(this.propsObj.openView && item.transactionId && item.transactionListId){
          this.openTransaction(item.transactionListId, item.transactionId);
        }
        // else if(this.propsObj.openAccount){
        //   this.openAccountDetails(item.accountId);
        // }
        else if(item.accountId){
          if(this.$route.params.reportId == 302 || this.$route.params.reportId == 402){
            let routereportId = this.$route.params.reportId == 302 ? 301 : 401;
            // removing period from local storage before route update
            localStorage.removeItem('report_period_'+routereportId);
            this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+routereportId, query:{"isFilter":true, "filterPartyId":item.accountId, "filterPartyName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
          }
          else{
            // removing period from local storage before route update
            localStorage.removeItem('report_period_201');
            // this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+201, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
            if(this.$route.params.reportId == 413 || this.$route.params.reportId == 414){
              this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/201', query:{"isFilter":true, "filtertypeFormName":"Expense", "itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
            }
            else if(this.$route.params.reportId == 504){
              if(!item.cols.isGroup){
                this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+505, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
              }
            }
            else if(this.$route.params.reportId == 605){
              this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+604, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
            }
            else{
              this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+201, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
            }
          }
        }
        else if(item.productId && this.$route.params.reportId != 108 && this.$route.params.reportId != 109 && this.$route.params.reportId != 309 && this.$route.params.reportId != 417 && this.$route.params.reportId != 104){
          // removing period from local storage before route update
          localStorage.removeItem('report_period_101');
          if(this.reportFilterObj.party){
            this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+101, query:{"itemId":item.productId, "itemName":item.productName, "isFilter":true, "filterPartyId":this.reportFilterObj.party.id, "filterPartyName":this.reportFilterObj.party.value, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
          }
          else{
            if(this.$route.params.reportId == 410){
              // this.$router.push('/masters/inventory/productandservices/items/'+item.productId);
              this.$router.push({path:'/'+this.$root.CurrentBusiness.BusinessID+'/'+this.$route.params.listId+'/product/items/'+item.productId, query:{inventory:0, back:1}});
            }
            else{
              if(this.$route.params.reportId == 105){
                this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+106, query:{"startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod, "itemId":item.cols.batchId, "itemName":item.cols.batchNumber ? item.productName + '/' + item.cols.batchNumber : item.productName}});  
              }
              else{
                this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+101, query:{"itemId":item.productId, "itemName":item.productName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
              }
            }
          }
        }
        else if(this.$route.params.reportId == 412 && item.expenseCategoryId){
          // this.$router.push('/masters/expensecategory/items/'+item.expenseCategoryId);
          this.$router.push({path:'/'+this.$root.CurrentBusiness.BusinessID+'/'+this.$route.params.listId+'/expense_category/items/'+item.expenseCategoryId, query:{back:1}});
        }
        else if((this.$route.params.reportId == 413 || this.$route.params.reportId == 414) && !item.accountId){
          let filterType = this.$route.params.reportId == 413 ? 2 : 3;
          this.$router.push({path:'/'+this.$root.CurrentBusiness.BusinessID+'/expense', query:{"tagId":this.guidWeb(), "transactionTypeId":20005, filterType:filterType, back:1, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
        }
         else if(this.$route.params.reportId == 104){
          this.fn_profitLossDetails(item);
        }

        let self = this;
        setTimeout(function(){
          self.propsObj.disableClick = false;
        },300);
      },

      fn_profitLossDetails: function(data){
        console.log('in');
        this.$parent.$parent.itemWiseProfitLossData = data.cols;
        setTimeout(() => {
          this.$parent.$parent.$refs['ref_dialogProfitLossDetails'].openDialogWeb();
        }, 100);
      },

      fn_tableHeight: function(){
        let subheaderHeight = 0;
        let itemSelectionRowHeight = 0;
        if(document.getElementsByClassName("table_view_details") && document.getElementsByClassName("table_view_details")[0]){
          subheaderHeight = document.getElementsByClassName("table_view_details")[0].offsetHeight;
        }

        if(document.getElementById('item_selection_row')){
          itemSelectionRowHeight = document.getElementById('item_selection_row').offsetHeight;
        }
        
        this.tableHeight = 'calc(100vh - 56px - ' + (subheaderHeight + itemSelectionRowHeight) + 'px - 3px)';
      },

      fn_getCustomDateClass: function(item){
        if(this.$route.params.reportId == 109){
          if(Number(item.cols['expiredIn']) <= 0){
            return 'redcolor';
          }
        }
      }

    },
    computed:{
      fn_getHeaders: function(){
        let headers = [];
        for(let i in this.propsObj.columns){
          let obj = {};
          obj.value = this.propsObj.columns[i];
          for(let j in this.propsObj.reportData.headerRow){
            if(obj.value == this.propsObj.reportData.headerRow[j].value){
              obj.text = this.propsObj.reportData.headerRow[j].headerName;
              headers.push(obj);
              break;
            }
          }
        }
        return headers;
      },

      // fn_tableHeight: function(){
      //   let subheaderHeight = 0;
      //   if(document.getElementsByClassName("reportdetails") && document.getElementsByClassName("reportdetails")[0]){
      //     subheaderHeight = document.getElementsByClassName("reportdetails")[0].offsetHeight;
      //   }
      //   return 'calc(100vh - 56px - ' + subheaderHeight + 'px)';
      //   // if(containerHeight && headerHeight && subheaderHeight && tableHeaderHeight){
      //   //   return containerHeight - headerHeight - subheaderHeight - tableHeaderHeight;
      //   // }
      //   // else{
      //   //   return 0;
      //   // }
      // }
    }
  }
</script>